/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Close_LabelInputs */

const en_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close modal`)
};

const fr_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre`)
};

const de_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modal schließen`)
};

const it_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi modale`)
};

const ru_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно`)
};

const es_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar modal`)
};

const zh_cn2_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭模态框`)
};

const ja_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モーダルを閉じる`)
};

const hi_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मॉडल बंद करें`)
};

const pt_pt2_batch_subtitle_export_close_label = /** @type {(inputs: Batch_Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal`)
};

/**
* | output |
* | --- |
* | "Close modal" |
*
* @param {Batch_Subtitle_Export_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_close_label = /** @type {((inputs?: Batch_Subtitle_Export_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_close_label(inputs)
	if (locale === "de") return de_batch_subtitle_export_close_label(inputs)
	if (locale === "it") return it_batch_subtitle_export_close_label(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_close_label(inputs)
	if (locale === "es") return es_batch_subtitle_export_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_close_label(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_close_label(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_close_label(inputs)
	return en_batch_subtitle_export_close_label(inputs)
});